<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="filter_cluster">Filter By Cluster</label>
            <v-select
              id="filter_cluster"
              v-model="selected.filter_cluster"
              :options="filterClusters"
              label="cluster_name"
              :disabled="state.busy"
              placeholder="-- Please Select Cluster --"
            >
              <template #option="{ cluster_name }">
                <span>{{ cluster_name }}</span>
              </template>
              <template #no-options="">
                No Available Clusters
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="filter_area">Filter By Area</label>
            <v-select
              id="filter_area"
              v-model="selected.filter_area"
              :options="list.areas"
              label="area_name"
              :disabled="state.busy"
              placeholder="-- Please Select Area --"
            >
              <template #option="{ area_name }">
                <span>{{ area_name }}</span>
              </template>
              <template #no-options="">
                No Available Areas
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group>
            <label>Filter By Crop</label>
            <v-select
              id="crop"
              v-model="selected.filter_crop"
              :options="list.crops"
              label="crop_name"
              :disabled="state.busy"
              placeholder="-- Please Select Crop --"
            >
              <template #option="{ crop_name }">
                <span>{{ crop_name }}</span>
              </template>
              <template #no-options="">
                No Available Crops
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="field_size">Filter By Land Size</label>
            <v-select
              id="field_size"
              v-model="selected.filter_field_size"
              :options="list.field_sizes"
              label="field_size_name"
              :disabled="(state.busy || selected.filter_crop === null)"
              placeholder="-- Please Select Land Size --"
            >
              <template #option="{ field_size_name }">
                <span>{{ field_size_name }}</span>
              </template>
              <template #no-options="">
                No Available Land Sizes
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="call_status">Filter By Last Call Status</label>
            <v-select
              id="call_status"
              v-model="selected.filter_call_status"
              :options="options.call_statuses"
              label="text"
              :disabled="state.busy"
              placeholder="-- Please Select Call Status --"
            >
              <template #option="{ text }">
                <span>{{ text }}</span>
              </template>
              <template #no-options="">
                No Available Call Statuses
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          sm="6"
        >
          <b-form-group>
            <label for="filter_cluster">Filter By Last Promotion</label>
            <v-select
              id="filter_cluster"
              v-model="selected.filter_promotion"
              :options="filterPromotions"
              label="promotion_name"
              :disabled="state.busy"
              placeholder="-- Please Select Promotion --"
            >
              <template #option="{ promotion_name }">
                <span>{{ promotion_name }}</span>
              </template>
              <template #no-options="">
                No Available Promotions
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            :disabled="tableSettings.totalRows < 1"
            class="mr-1"
            variant="primary"
            @click="state.selected ? onUnSelectAll() : onSelectAll()"
          >
            {{ state.selected ? 'Uncheck Current' : 'Select Current' }}
          </b-button>

          <b-button
            :disabled="selected.campaign_data.length < 1"
            variant="secondary"
            @click="onShowAssignModal"
          >
            Assign Data
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
        </template>

        <template #cell(selected)="row">
          <div class="text-nowrap">
            <div class="form-group">
              <b-form-checkbox
                v-model="selected.campaign_data"
                :value="row.item.id"
              />
            </div>
          </div>
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-assign-data"
      scrollable
      no-close-on-backdrop
      title="Assign Data"
      @ok="onConfirmAction"
    >
      <ValidationObserver ref="form">
        <form
          role="form"
          novalidate
        >
          <div class="col-12 mb-5">
            <ValidationProvider
              #default="{ errors }"
              name="agent"
              vid="agent"
              rules="required"
            >
              <b-form-group>
                <label for="agents">Agent</label>
                <v-select
                  id="agents"
                  v-model="selected.agent"
                  :options="list.agents"
                  :class="`${errors.length > 0 ? 'is-invalid' : ''}`"
                  label="full_name"
                >
                  <template #option="{ full_name }">
                    <strong>{{ full_name }}</strong>
                  </template>
                  <template #no-options="">
                    No Available Agents
                  </template>
                </v-select>
                <div
                  v-if="errors.length > 0"
                  class="invalid-feedback"
                >
                  <span>{{ errors[0] }}</span>
                </div>
              </b-form-group>
            </ValidationProvider>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          Proceed
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>

  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { AxiosError, SupervisorCampaignDataService, SharedListService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'SupervisorCampaignData',

  middleware: ['auth', 'supervisor'],

  mixins: [formatter],

  metaInfo () {
    return {
      title: 'Campaign Data'
    }
  },

  data () {
    return {
      state: {
        busy: false,
        selected: false
      },
      filter: {
        cluster: 'all',
        area: 'all',
        customer_type: 'all',
        crop: 'all',
        call_status: 'all',
        promotion: 'all'
      },
      list: {
        clusters: [],
        areas: [],
        crops: [],
        field_sizes: [],
        promotions: []
      },
      options: {
        call_statuses: [
          { text: 'None', value: 'None' },
          { text: 'Connected', value: 'Connected' },
          { text: 'Unsuccessful', value: 'Unsuccessful' }
        ]
      },
      selected: {
        agent: null,
        campaign_data: [],
        filter_cluster: null,
        filter_area: null,
        filer_field_Size: null,
        filter_crop: null,
        filter_call_status: null,
        filter_promotion: null
      },
      taggingData: {
        agent: null,
        selected: []
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          { key: 'selected' },
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'first_name', sortable: true },
          { key: 'last_name', sortable: true },
          { key: 'customer_type' },
          { key: 'mobile_number' },
          { key: 'last_call_status', label: 'last status' },
          { key: 'last_call', formatter: this.dateTimeFormatterLong, sortable: true },
          { key: 'last_agent_name', label: 'last_agent' },
          { key: 'promotion_name', label: 'last promotion' },
          { key: 'unsuccessful_reason_name', label: 'last unsuccessful reason' },
          { key: 'updated_at', formatter: this.dateTimeFormatter }
        ]
      }
    }
  },

  computed: {
    filterPromotions () {
      return [
        { id: 'none', promotion_name: 'No Promotion' }
      ].concat(this.list.promotions)
    },

    filterClusters () {
      return [
        { id: 'no-cluster', cluster_name: 'No Cluster' }
      ].concat(this.list.clusters)
    }
  },

  watch: {
    'selected.filter_cluster' (value) {
      this.filter.cluster = value?.id || 'all'
      this.getAreas(value?.id || null)
      this.onFilterChanged()
    },

    'selected.filter_area' (value) {
      this.filter.area = value?.id || 'all'
      this.onFilterChanged()
    },

    'selected.filter_crop' (value) {
      this.filter.crop = value?.id || 'all'
      if (value === null) {
        this.selected.filter_field_size = null
      }
      this.onFilterChanged()
    },

    'selected.filter_field_size' (value) {
      this.filter.field_size = value?.id || 'all'
      this.onFilterChanged()
    },

    'selected.filter_call_status' (value) {
      this.filter.call_status = value?.value || 'all'
      this.onFilterChanged()
    },

    'selected.filter_promotion' (value) {
      this.filter.promotion = value?.id || 'all'
      this.onFilterChanged()
    },

    'selected.agent' (value) {
      this.taggingData.agent = value?.id || null
    },

    'selected.campaign_data' (value) {
      this.taggingData.selected = value

      if (value.length > 0) {
        this.state.selected = true
      } else {
        this.state.selected = false
      }
    }
  },

  mounted () {
    core.index()
    this.getClusters()
    this.getCrops()
    this.getFieldSizes()
    this.getPromotions()
    this.getAgents()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await SupervisorCampaignDataService.get(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            filter_cluster: this.filter.cluster,
            filter_area: this.filter.area,
            filter_field_size: this.filter.field_size,
            filter_crop: this.filter.crop,
            filter_call_status: this.filter.call_status,
            filter_promotion: this.filter.promotion
          })
        )
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getClusters () {
      await SharedListService.getClusters().then(({ data }) => {
        this.list.clusters = data
      })
    },

    async getAreas (cluster) {
      this.selected.filter_area = null
      if (cluster) {
        this.list.areas = []
        await SharedListService.getAreas(`cluster_id=${cluster}`).then(({ data }) => {
          this.list.areas = data
        })
      } else {
        this.list.areas = []
      }
    },

    async getCrops () {
      await SharedListService.getCrops().then(({ data }) => {
        this.list.crops = data
      })
    },

    async getFieldSizes () {
      await SharedListService.getFieldSizes().then(({ data }) => {
        this.list.field_sizes = data
      })
    },

    async getPromotions () {
      await SharedListService.getPromotions().then(({ data }) => {
        this.list.promotions = data
      })
    },

    async getAgents () {
      await SharedListService.getAgents().then(({ data }) => {
        this.list.agents = data
      })
    },

    onShowAssignModal () {
      this.selected.agent = null
      this.$bvModal.show('modal-assign-data')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: 'Are you sure you want to assign this campaign data to this current agent?',
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              return this.onFormPutSubmit()
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            centered: true
          })
        }
      })
    },

    async onFormPutSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        SupervisorCampaignDataService.put(this.taggingData).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-assign-data')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          })
            .then(() => {
              this.$refs.table.refresh()
              this.state.selected = false
              this.selected.campaign_data = []
            })
        })
          .catch(error => {
            this.state.busy = false
            if (error instanceof AxiosError) {
              if (error.code === 422) {
                this.$refs.form.setErrors(error.message)
                resolve(error)
              }
            }
          })
      })
    },

    onSelectAll () {
      this.state.selected = true
      this.selected.campaign_data = this.$refs.table.localItems?.map(item => {
        return item.id
      })
    },

    onUnSelectAll () {
      this.state.selected = false
      this.selected.campaign_data = []
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    }
  }
}
</script>
